import * as actionTypes from '../../../../models/actionTypes';
import { AlchemyResult } from '../../../../models/apiModels';

export const initializeAlchemyStateOnGetHelp = (searchQuery: string) => {
  return {
    type: actionTypes.INIT_SELF_HELP_ALCHEMY_ON_SESSION_START,
    searchQuery,
  };
};

export const fetchAlchemySuccess = (results: AlchemyResult) => {
  return {
    type: actionTypes.FETCH_ALCHEMY_SUCCESS,
    alchemyResults: results,
  };
};

export const fetchAlchemySuccessThirdParty = (results: AlchemyResult) => {
  return {
    type: actionTypes.FETCH_ALCHEMY_SUCCESS_3P,
    alchemyResults: results,
  };
};

export const fetchAlchemyError = (results: AlchemyResult) => {
  return {
    type: actionTypes.FETCH_ALCHEMY_ERROR,
    alchemyResults: results,
  };
};

export const setExpandedInsight = (insightIndex: number, isExpanded: boolean) => {
  return {
    type: actionTypes.SET_EXPANDED_INSIGHT,
    insightIndex,
    isExpanded,
  };
};

export const setRelatedCorrelationIds = () => {
  return {
    type: actionTypes.SET_RELATED_CORRELATION_IDS,
  };
};

export const clearRelatedCorrelationIds = () => {
  return {
    type: actionTypes.CLEAR_RELATED_CORRELATION_IDS,
  };
};

export const resetSearchSession = () => {
  return {
    type: actionTypes.RESET_SEARCH_SESSION,
  };
};

export const toggleTopResultHeight = (index: number) => {
  return {
    type: actionTypes.TOGGLE_CARD_HEIGHT,
    payload: index,
  };
};

export const toggleTopResultContent = (index: number) => {
  return {
    type: actionTypes.TOGGLE_CONTENT,
    payload: index,
  };
};

export const updateDialogId = (dialogId: string) => {
  return {
    type: actionTypes.UPDATE_DIALOG_ID,
    dialogId: dialogId,
  };
};

export const toggleShowMoreInsights = () => { 
  return {
    type: actionTypes.TOGGLE_SEE_MORE_INSIGHTS,
  };
};